/**
 * Google Analytics utility functions
 * Handles consent-aware tracking
 */

declare global {
  interface Window {
    gtag: (...args: unknown[]) => void;
    dataLayer: unknown[];
  }
}

const GA_MEASUREMENT_ID = 'G-BCPG3SL4R0';

/**
 * Updates Google Analytics consent state
 * Call this when user accepts/declines analytics cookies
 */
export function updateAnalyticsConsent(granted: boolean): void {
  if (typeof window.gtag !== 'function') return;
  
  window.gtag('consent', 'update', {
    'analytics_storage': granted ? 'granted' : 'denied'
  });
}

/**
 * Tracks a page view - call on route changes
 */
export function trackPageView(path: string, title?: string): void {
  if (typeof window.gtag !== 'function') return;
  
  window.gtag('event', 'page_view', {
    page_path: path,
    page_title: title,
    send_to: GA_MEASUREMENT_ID
  });
}

/**
 * Tracks custom events
 */
export function trackEvent(
  eventName: string, 
  params?: Record<string, string | number | boolean>
): void {
  if (typeof window.gtag !== 'function') return;
  
  window.gtag('event', eventName, params);
}
